// Page
export const RESOLVE_SLUG = "RESOLVE_SLUG";
export const RESOLVE_SLUG_SUCCESS = "RESOLVE_SLUG_SUCCESS";
export const RESOLVE_SLUG_ERROR = "RESOLVE_SLUG_ERROR";

export const RESOLVE_REDIRECT_SUCCESS = "RESOLVE_REDIRECT_SUCCESS";

export const RESOLVE_SEARCH_SUCCESS = "RESOLVE_SEARCH_SUCCESS";

// Get Product By ID.
export const GET_PRODUCT_BY_ID = "GET_PRODUCT_BY_ID";
export const GET_PRODUCT_BY_ID_SUCCESS = "GET_PRODUCT_BY_ID_SUCCESS";
export const GET_PRODUCT_BY_ID_ERROR = "GET_PRODUCT_BY_ID_ERROR";

// Automated discounts
export const GET_AUTOMATED_DISCOUNTS = "GET_AUTOMATED_DISCOUNTS";
export const GET_AUTOMATED_DISCOUNTS_SUCCESS = "GET_AUTOMATED_DISCOUNTS_SUCCESS";
export const GET_AUTOMATED_DISCOUNTS_ERROR = "GET_AUTOMATED_DISCOUNTS_ERROR";
